import { render, staticRenderFns } from "./tablec.vue?vue&type=template&id=d8ba403a&scoped=true"
import script from "./tablec.vue?vue&type=script&lang=js"
export * from "./tablec.vue?vue&type=script&lang=js"
import style0 from "./tablec.vue?vue&type=style&index=0&id=d8ba403a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ba403a",
  null
  
)

export default component.exports